import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import CacheBuster from "react-cache-buster";

import "./styles/global.css";
import Loading from "./components/placeholder/Loading";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { version } from "../package.json";
import { BrowserRouter } from "react-router";
import App from "./App";
import { reloadPage } from "./utils/browserUtils";

const isProduction = import.meta.env.PROD;

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      onCacheClear={() => {
        // Reload the page when cache is cleared
        reloadPage();
      }}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </CacheBuster>
  </StrictMode>
);
